export const getWaffleFlags = (state) => state.courseDetail?.waffleFlags;
